import axios from 'lib/utils/axios';
import logrocket from '@/services/logrocket';
import HTTPService from '@/services/Http';

import editBillRequest from 'api/requests/bill/editBill';

async function fetchLimits({ commit }) {
  try {
    const { data } = await HTTPService.getBillLimits();
    commit('LIMITS', data);
  } catch (error) {
    commit('LIMITS', {});
  }
}

async function fetchWriteOffOptions({ commit }) {
  try {
    const { data } = await HTTPService.fetchWriteOffOptions();
    commit('WRITE_OFF_OPTIONS', data);
  } catch (error) {
    commit('WRITE_OFF_OPTIONS', []);
  }
}

// eslint-disable-next-line no-unused-vars
async function editBill({ commit }, payload) {
  try {
    const data = await editBillRequest(axios, payload);

    return data;
  } catch (error) {
    logrocket.logger(error);
    throw new Error(error);
  }
}

export default {
  fetchLimits,
  fetchWriteOffOptions,
  editBill,
};
